export const MEMO_EMPTY_ARRAY: never[] = Object.freeze([]) as never[];
